module.exports = __webpack_public_path__ + "static/media/static-ca.2af78dca.png";